// src/features/static-pages/ReleaseNotes.jsx
import React from 'react';
import { ChevronRight } from 'lucide-react';

const ReleaseNotes = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-20 px-4">
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-bold mb-12">Release Notes</h1>

        {/* Current Release */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-6">Alpha 0.1.0 - Current Release</h2>
          <div className="bg-gray-900/50 rounded-lg p-6 border border-gray-800">
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-500 mt-0.5 flex-shrink-0" />
                <span>3D development environment with spatial navigation</span>
              </li>
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-500 mt-0.5 flex-shrink-0" />
                <span>Visual node-based workflow editor</span>
              </li>
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-500 mt-0.5 flex-shrink-0" />
                <span>API generation from visual designs</span>
              </li>
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-500 mt-0.5 flex-shrink-0" />
                <span>Multiple LLM integrations for code generation</span>
              </li>
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-500 mt-0.5 flex-shrink-0" />
                <span>System prompt builder with templates</span>
              </li>
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-500 mt-0.5 flex-shrink-0" />
                <span>Persistent workspace with automatic saving</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Coming Soon */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-6">Coming Soon</h2>
          <div className="bg-gray-900/50 rounded-lg p-6 border border-gray-800">
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-600 mt-0.5 flex-shrink-0" />
                <span>Advanced visual node editor</span>
              </li>
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-600 mt-0.5 flex-shrink-0" />
                <span>Mechanistic interpretability module</span>
              </li>
              <li className="flex items-start gap-2">
                <ChevronRight size={20} className="text-gray-600 mt-0.5 flex-shrink-0" />
                <span>AI Training Module</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;